export default "__VITE_ASSET__BavpLt9H__"